import BrowserStorage from '@123/druid/dist/Services/Storage/BrowserStorage';
import CookieStorageEngine from '@123/druid/dist/Services/Storage/Cookie/CookieStorageEngine';

export default class CookieStorage extends BrowserStorage {
    public static readonly TTL: number = 24 * 60 * 60 * 1000; // 1 day

    constructor(options?: CookieInit) {
        super(
            new CookieStorageEngine({
                default: {
                    expires: new Date().getTime() + 365 * CookieStorage.TTL,
                    path: '/',
                    ...options,
                } as CookieInit,
            }),
        );
    }
}
